import { sendStats } from "./stats";

export const wideo = () => {
  const $carousel = $(".owl-carousel.owl-1-item");

  const isMobile = () => $(window).width() < 768;

  const initPlayer = ($playerEl) => {
    if (!$playerEl.length) return;
    if ($playerEl.data("initialized")) return;
    $playerEl.data("initialized", true);

    const url = $playerEl.data("url");
    const playerId = $playerEl.attr("id") || "player_" + Math.floor(Math.random() * 10000);
    $playerEl.attr("id", playerId);

    WP.push(() => {
      let playerInitialized = false;
      let statsQuadrantsPos = {};
      let clipName, clipMid;

      const player = new WP.player({
        url,
        target: playerId,
        adv: false,
        hiderelated: true,
        extendedrelated: false,
        floatingplayer: false,
        autoplay: false,
        forceliteembed: false,
      });

      $playerEl.data("playerInstance", player);

      player.on("INIT", () => { if (!playerInitialized) playerInitialized = true; });
      player.on("START_MOVIE", () => {
        const data = player.getClipData();
        clipName = data.title; clipMid = data.mid;
        document.querySelectorAll(".section--head--button").forEach(el => el.style.display = "none");
        sendStats("video", "view", clipName);
      });
      player.on("END_MOVIE", () => {
        document.querySelectorAll(".section--head--button").forEach(el => el.style.display = "block");
        sendStats("video", "end", clipName);
      });
      player.on("UPDATE_POSITION", () => {
        const p = Math.round(player.getPosition() * 100);
        statsQuadrantsPos[clipMid] ||= {};
        if (p >= 25 && p < 50 && !statsQuadrantsPos[clipMid][25]) { statsQuadrantsPos[clipMid][25] = 1; sendStats("video", "quarter=25", clipName); }
        if (p >= 50 && p < 75 && !statsQuadrantsPos[clipMid][50]) { statsQuadrantsPos[clipMid][50] = 1; sendStats("video", "quarter=50", clipName); }
        if (p >= 75 && p < 100 && !statsQuadrantsPos[clipMid][75]) { statsQuadrantsPos[clipMid][75] = 1; sendStats("video", "quarter=75", clipName); }
      });
    });
  };

  const updateItems = () => {

    if (isMobile()) {
      $carousel.find(".player").each(function () {
        const $player = $(this);
        $player.show();
        initPlayer($player);
      });

      $carousel.find(".thumbnail-wrapper").hide();
      return;
    }

    const $items = $carousel.find(".owl-item");

    $items.each(function () {
      const $player = $(this).find(".player");
      const $thumbnail = $(this).find(".thumbnail-wrapper");
      const playerInstance = $player.data("playerInstance");

      if ($(this).hasClass("center")) {
        $player.show();
        $thumbnail.hide();
        initPlayer($player);
      } else {
        $player.hide();
        $thumbnail.show();
        if (playerInstance && playerInstance.isPlaying()) playerInstance.stop();
      }
    });
  };

  $carousel.on("initialized.owl.carousel refreshed.owl.carousel", () => {
    updateItems();
  });

  $carousel.on("translated.owl.carousel", () => {
    updateItems();
  });

  $(window).on("resize", () => {
    updateItems();
  });

  $carousel.on("click", ".thumbnail-wrapper", function () {
    const $item = $(this).closest(".owl-item");
    const index = $item.index();
    $carousel.trigger("to.owl.carousel", [index, 300]);
  });
};